// Centralized image references.
// Real product images supplied by the client. Replace any URL below if
// you receive higher-resolution versions later.

const REAL_1 =
    "https://customer-assets.emergentagent.com/wingman/1e04184f-5f7b-4f3b-991d-c48194442de9/attachments/097fbe8fc328423e8bcbde9abd9a78ed_file_000000004d7871fd9b82cd4456ce9c9a.png";
const REAL_2 =
    "https://customer-assets.emergentagent.com/wingman/1e04184f-5f7b-4f3b-991d-c48194442de9/attachments/29e4f7ac54e34af09880c70baa068c99_file_0000000080ec71fd9eb995fda1a768bd.png";
const REAL_3 =
    "https://customer-assets.emergentagent.com/wingman/1e04184f-5f7b-4f3b-991d-c48194442de9/attachments/7e819134c2fc4d7c9877994226f8bbf7_file_0000000010e871fda8571d637ab94df1.png";

// Lifestyle images (no real lifestyle photography provided yet — using
// high-quality editorial stock as placeholders until real lifestyle
// photos are supplied).
const LIFESTYLE_HERO =
    "https://images.unsplash.com/photo-1658928785463-990d81c7d4f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const LIFESTYLE_BED =
    "https://images.unsplash.com/photo-1674871289908-4854dc4ae8b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const IMAGES = {
    pillowHero: {
        src: REAL_1,
        alt: "Premium Contour Pillow — editorial product portrait",
    },
    pillowProduct: {
        src: REAL_1,
        alt: "Premium Contour Pillow on a clean light background",
    },
    pillowSide: {
        src: REAL_2,
        alt: "Side profile of the Premium Contour Pillow showing the ergonomic contour",
    },
    pillowDetail: {
        src: REAL_3,
        alt: "Close-up of the breathable soft-blue cover fabric",
    },
    pillowLifestyle: {
        src: LIFESTYLE_HERO,
        alt: "Editorial bedroom morning light scene",
    },
    pillowBed: {
        src: LIFESTYLE_BED,
        alt: "Premium bedding ambiance, editorial photography",
    },
    pillowFinalCta: {
        src: REAL_2,
        alt: "Premium Contour Pillow — final feature shot",
    },
};
